module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "add-article-wrapper form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('section', {
    staticClass: "add-article-section add-article-section--heading"
  }, [_c('div', {
    staticClass: "add-article-details"
  }, [_c('div', {
    staticClass: "form-elements"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('div', {
    staticClass: "wrap-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page.title),
      expression: "page.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "name": "title",
      "placeholder": "Type in to add title..."
    },
    domProps: {
      "value": (_vm.page.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.page, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('title')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('title')) + "\n                        ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "control-panel"
  }, [_c('div', {
    staticClass: "wrap-button"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deletePage()
      }
    }
  }, [_c('icon', {
    staticClass: "icon-btn-ctr",
    attrs: {
      "name": "remove"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Delete page")])], 1)])]), _vm._v(" "), _c('statusbar', {
    attrs: {
      "status": _vm.page.status,
      "updatedAt": _vm.updatedAt
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "add-article-body"
  }, [_c('div', {
    staticClass: "add-article-sections"
  }, [_c('section', {
    staticClass: "add-article-section"
  }, [_c('h2', {
    staticClass: "add-article-section__title"
  }, [_vm._v("Title and body")]), _vm._v(" "), _c('vue-editor', {
    staticClass: "article-editor",
    attrs: {
      "editorToolbar": _vm.editorToolbar,
      "name": "content"
    },
    model: {
      value: (_vm.page.content.content),
      callback: function($$v) {
        _vm.$set(_vm.page.content, "content", $$v)
      },
      expression: "page.content.content"
    }
  }), _vm._v(" "), (_vm.errors.has('description')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('content')) + "\n                ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "add-article-actions"
  }, [_c('button', {
    staticClass: "action-btn--back",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/admin/articles-list')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "rotate-left"
    }
  }), _vm._v("\n                Back to list\n            ")], 1), _vm._v(" "), _c('button', {
    staticClass: "action-btn action-btn--preview icon-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.preview()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "textInButton"
  }, [_vm._v("Preview page")])]), _vm._v(" "), _c('button', {
    staticClass: "action-btn action-btn--exit icon-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/admin/static-pages')
      }
    }
  }, [_vm._m(1), _vm._v("Exit without saving\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "action-btn action-btn--draft icon-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveDraft()
      }
    }
  }, [_vm._m(2), _vm._v("Save as draft\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "action-btn action-btn--publish icon-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.publish()
      }
    }
  }, [_vm._m(3), _vm._v("Publish page\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-button"
  }, [_c('img', {
    staticClass: "previe-icon",
    attrs: {
      "src": require("../../../assets/img/main/previeIcon.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-button"
  }, [_c('img', {
    staticClass: "export-icon",
    attrs: {
      "src": require("../../../assets/img/main/export.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-button"
  }, [_c('img', {
    staticClass: "saveAndDraft-icon",
    attrs: {
      "src": require("../../../assets/img/main/saveAndDraft.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-button"
  }, [_c('img', {
    staticClass: "earth-icon",
    attrs: {
      "src": require("../../../assets/img/main/earth.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1270eecc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/staticpage/staticpage.vue
// module id = 891
// module chunks = 1